export const landingMarkup = `
<!-- Nav -->
<nav id="nav">
  <div class="logo">scico<span class="dot">.</span></div>
  <div class="nav-btns">
    <button class="nav-btn btn-outline" data-auth="login">Log In</button>
    <button class="nav-btn btn-filled" data-auth="signup">Get Started</button>
  </div>
</nav>

<!-- Progress Bar -->
<div id="progress-track"><div id="progress-fill"></div></div>

<!-- Nav Dots -->
<div id="nav-dots">
  <button class="nav-dot active" data-index="0" data-label="Hero"></button>
  <button class="nav-dot" data-index="1" data-label="Physics"></button>
  <button class="nav-dot" data-index="2" data-label="Astronomy"></button>
  <button class="nav-dot" data-index="3" data-label="Astrophysics"></button>
  <button class="nav-dot" data-index="4" data-label="Quantum"></button>
</div>

<!-- Tooltip -->
<div id="tooltip"></div>

<!-- Scroll Container -->
<div id="scroll-container">

  <!-- SECTION 1: HERO -->
  <section class="section" id="section-hero">
    <div class="hero-bg"></div>
    <div class="section-content visible">
      <div class="left-col">
        <div class="tag">🚀 Interactive Science Learning</div>
        <h1 class="headline">Where <span class="highlight">Science</span> Comes<br>to Life.</h1>
        <p class="body-text">Dive deep into physics, astronomy, astrophysics, and quantum mechanics. Grade-based chapters, interactive lessons, and science that actually sticks.</p>
        <div class="cta-row">
          <button class="cta-btn cta-primary" data-auth="start">Start Learning →</button>
          <button class="cta-btn cta-outline" data-scroll="section-physics">See How It Works</button>
        </div>
        <div class="course-grid">
          <div class="course-card physics"><div class="name">Physics</div><div class="label">Course</div></div>
          <div class="course-card astronomy"><div class="name">Astronomy</div><div class="label">Course</div></div>
          <div class="course-card astrophysics"><div class="name">Astrophysics</div><div class="label">Course</div></div>
          <div class="course-card quantum"><div class="name">Quantum Mechanics</div><div class="label">Course</div></div>
        </div>
      </div>
      <div class="right-col">
        <div class="atom-illustration">
          <div class="atom-core"></div>
          <div class="orbit-ring orbit-ring-1"><div class="electron electron-1"></div></div>
          <div class="orbit-ring orbit-ring-2"><div class="electron electron-2"></div></div>
          <div class="orbit-ring orbit-ring-3"><div class="electron electron-3"></div></div>
          <div class="particle-trail pt-1"></div>
          <div class="particle-trail pt-2"></div>
          <div class="particle-trail pt-3"></div>
          <div class="particle-trail pt-4"></div>
        </div>
      </div>
    </div>
    <div class="scroll-hint"><span>SCROLL</span><div class="scroll-line"></div></div>
  </section>

  <!-- SECTION 2: PHYSICS -->
  <section class="section" id="section-physics">
    <div class="physics-bg"></div>
    <div id="physics-particles" style="position:absolute;inset:0;overflow:hidden;will-change:transform;transition:transform 0.1s linear"></div>
    <div class="section-content">
      <div class="left-col">
        <div class="tag" style="color:#e8527a;border-color:rgba(232,82,122,0.3)">⚡ Classical & Modern Physics</div>
        <h2 class="headline">Master the<br><span class="highlight-pink">Laws of</span><br>Physics</h2>
        <p class="body-text">From Newton's laws to Einstein's relativity, explore the fundamental forces that govern our universe. Understand motion, energy, waves, and the mathematics that describes reality.</p>
        <div class="cta-row"><button class="cta-btn cta-red" data-auth="physics">Explore Physics →</button></div>
        <div class="feature-row primary"><span class="feature-icon" style="color:#e8527a">⚡</span><div><div class="feature-title">Mechanics</div><div class="feature-desc">Newton's laws and motion</div></div></div>
        <div class="feature-row primary"><span class="feature-icon" style="color:#e8527a">🔥</span><div><div class="feature-title">Thermodynamics</div><div class="feature-desc">Heat, energy, and entropy</div></div></div>
        <div class="feature-row primary"><span class="feature-icon" style="color:#e8527a">〰</span><div><div class="feature-title">Waves & Optics</div><div class="feature-desc">Light, sound, and oscillations</div></div></div>
        <div class="feature-row primary"><span class="feature-icon" style="color:#e8527a">⚛️</span><div><div class="feature-title">Electromagnetism</div><div class="feature-desc">Electricity and magnetism</div></div></div>
      </div>
      <div class="right-col">
        <div id="physics-models" class="models-container">
          <div id="physics-animation-container" style="position:absolute;inset:0;pointer-events:none;"></div>
          <!-- Hydrogen -->
          <div class="model hydrogen" data-label="Hydrogen Atom">
            <div class="nucleus" style="width:30px;height:30px"><div class="proton" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)"></div></div>
            <div class="electron-cloud" style="width:150px;height:150px"><div class="probability"></div></div>
          </div>
          <!-- Helium -->
          <div class="model helium" data-label="Helium Atom">
            <div class="nucleus" style="width:45px;height:45px">
              <div class="proton" style="position:absolute;top:6px;left:6px"></div>
              <div class="proton" style="position:absolute;top:20px;left:22px"></div>
              <div class="neutron" style="position:absolute;top:6px;left:22px"></div>
              <div class="neutron" style="position:absolute;top:22px;left:4px"></div>
            </div>
            <div class="electron-cloud" style="width:80px;height:80px"><div class="probability"></div></div>
            <div class="electron-cloud" style="width:150px;height:150px;transform:translate(-50%,-50%) rotateX(45deg)"><div class="probability"></div></div>
          </div>
          <!-- Carbon -->
          <div class="model carbon" data-label="Carbon Atom">
            <div class="nucleus" style="width:55px;height:55px">
              <div class="proton" style="position:absolute;top:8px;left:12px"></div>
              <div class="proton" style="position:absolute;top:20px;left:28px"></div>
              <div class="proton" style="position:absolute;top:30px;left:14px"></div>
              <div class="neutron" style="position:absolute;top:8px;left:28px"></div>
              <div class="neutron" style="position:absolute;top:22px;left:8px"></div>
              <div class="neutron" style="position:absolute;top:32px;left:26px"></div>
            </div>
            <div class="electron-cloud" style="width:100px;height:100px"><div class="probability"></div></div>
            <div class="electron-cloud" style="width:160px;height:160px;transform:translate(-50%,-50%) rotateX(45deg)"><div class="probability"></div></div>
            <div class="electron-cloud" style="width:200px;height:200px;transform:translate(-50%,-50%) rotateX(90deg)"><div class="probability"></div></div>
          </div>
          <!-- Wave Function -->
          <div class="model wave-function" data-label="Quantum Wave Function">
            <div class="wave-surface"></div>
            <div class="wave-node" style="top:20%;left:20%"></div>
            <div class="wave-node" style="top:50%;left:50%;animation-delay:0.5s"></div>
            <div class="wave-node" style="top:80%;left:80%;animation-delay:1s"></div>
          </div>
          <!-- Collider -->
          <div class="model collider" data-label="Particle Collider">
            <div class="collider-ring ring-1"></div>
            <div class="collider-ring ring-2"></div>
            <div class="collider-ring ring-3"></div>
            <div class="beam beam-1"></div>
            <div class="beam beam-2"></div>
            <div class="spark"></div>
          </div>
          <!-- Double Slit -->
          <div class="model double-slit" data-label="Double Slit Experiment">
            <div class="barrier"></div>
            <div class="slit-gap slit-gap-1"></div>
            <div class="slit-gap slit-gap-2"></div>
          </div>
          <!-- Entanglement -->
          <div class="model entanglement" data-label="Quantum Entanglement">
            <div class="entangle-particle ep-left"></div>
            <div class="entangle-particle ep-right"></div>
            <div class="entangle-conn"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION 3: ASTRONOMY -->
  <section class="section" id="section-astronomy">
    <div class="astro-bg"></div>
    <div id="astronomy-stars" style="position:absolute;inset:0;overflow:hidden;will-change:transform;transition:transform 0.1s linear"></div>
    <div class="section-content">
      <div class="left-col">
        <div class="tag" style="color:#fbbf24;border-color:rgba(251,191,36,0.3)">🌌 Space & Astronomy</div>
        <h2 class="headline">Journey Through the<br><span class="highlight-gold">Cosmos</span></h2>
        <p class="body-text">Blast off into space! Explore our solar system, witness galaxies collide, peer into black holes, and travel to the edges of the observable universe. Your cosmic adventure starts here.</p>
        <div class="cta-row"><button class="cta-btn cta-gold" data-auth="astronomy">Explore Astronomy →</button></div>
        <div class="feature-row gold"><span class="feature-icon">🚀</span><div><div class="feature-title">Rocket Science</div><div class="feature-desc">Interactive rocket launches & space missions</div></div></div>
        <div class="feature-row gold"><span class="feature-icon">🪐</span><div><div class="feature-title">Solar System</div><div class="feature-desc">3D planet exploration & orbital mechanics</div></div></div>
        <div class="feature-row gold"><span class="feature-icon">🌀</span><div><div class="feature-title">Observable Universe</div><div class="feature-desc">Travel to galaxies & beyond the Milky Way</div></div></div>
        <div class="feature-row gold"><span class="feature-icon">🛰️</span><div><div class="feature-title">Space Exploration</div><div class="feature-desc">Missions to Mars, Moon & deep space</div></div></div>
      </div>
      <div class="right-col">
        <div id="astronomy-models" class="models-container">
          <!-- Solar System -->
          <div class="model solar-system" data-label="Solar System">
            <div class="sun"></div>
            <div class="orbit" style="width:75px;height:75px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="orbit" style="width:110px;height:110px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="orbit" style="width:150px;height:150px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="orbit" style="width:195px;height:195px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="orbit" style="width:240px;height:240px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="orbit" style="width:285px;height:285px;transform:translate(-50%,-50%);top:50%;left:50%"></div>
            <div class="planet-orbit" style="width:75px;height:75px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 5s linear infinite"><div class="planet mercury"></div></div>
            <div class="planet-orbit" style="width:110px;height:110px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 8s linear infinite"><div class="planet venus"></div></div>
            <div class="planet-orbit" style="width:150px;height:150px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 12s linear infinite"><div class="planet earth"></div></div>
            <div class="planet-orbit" style="width:195px;height:195px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 16s linear infinite"><div class="planet mars"></div></div>
            <div class="planet-orbit" style="width:240px;height:240px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 20s linear infinite"><div class="planet jupiter"></div></div>
            <div class="planet-orbit" style="width:285px;height:285px;transform:translate(-50%,-50%);top:50%;left:50%;animation:planetOrbit 24s linear infinite"><div class="planet saturn-wrapper"><div class="saturn-body"></div><div class="saturn-ring-el"></div></div></div>
          </div>
          <!-- Galaxy -->
          <div class="model galaxy" data-label="Spiral Galaxy">
            <div class="galaxy-core"></div>
            <div class="spiral-arm"></div><div class="spiral-arm"></div><div class="spiral-arm"></div><div class="spiral-arm"></div>
          </div>
          <!-- Black Hole -->
          <div class="model black-hole" data-label="Black Hole TON 618">
            <div class="event-horizon"></div>
            <div class="accretion-disk"></div>
            <div class="grav-lens"></div>
            <div class="bh-jet jet-top"></div>
            <div class="bh-jet jet-bottom"></div>
          </div>
          <!-- Nebula -->
          <div class="model nebula" data-label="Nebula">
            <div class="nebula-cloud nc-1"></div><div class="nebula-cloud nc-2"></div>
            <div class="nebula-cloud nc-3"></div><div class="nebula-cloud nc-4"></div>
          </div>
          <!-- Rockets -->
          <div class="model rocket-wrapper rocket-1" data-label="Rocket"><div class="rocket"><div class="rocket-nose"></div><div class="rocket-body"></div><div class="rocket-window"></div><div class="rocket-fin-l"></div><div class="rocket-fin-r"></div><div class="rocket-flame"></div></div></div>
          <div class="model rocket-wrapper rocket-2" data-label="Rocket"><div class="rocket"><div class="rocket-nose"></div><div class="rocket-body"></div><div class="rocket-window"></div><div class="rocket-fin-l"></div><div class="rocket-fin-r"></div><div class="rocket-flame"></div></div></div>
          <div class="model rocket-wrapper rocket-3" data-label="Rocket"><div class="rocket"><div class="rocket-nose"></div><div class="rocket-body"></div><div class="rocket-window"></div><div class="rocket-fin-l"></div><div class="rocket-fin-r"></div><div class="rocket-flame"></div></div></div>
          <!-- Satellites -->
          <div class="model satellite-wrapper sat-1" data-label="Satellite"><div class="sat-body"></div><div class="solar-panel sp-left"></div><div class="solar-panel sp-right"></div><div class="sat-antenna"></div></div>
          <div class="model satellite-wrapper sat-2" data-label="Satellite"><div class="sat-body"></div><div class="solar-panel sp-left"></div><div class="solar-panel sp-right"></div><div class="sat-antenna"></div></div>
          <!-- Asteroids -->
          <div class="model asteroid asteroid-1" data-label="Asteroid"><div class="crater" style="width:6px;height:6px;top:4px;left:8px"></div><div class="crater" style="width:4px;height:4px;top:12px;left:16px"></div></div>
          <div class="model asteroid asteroid-2" data-label="Asteroid"><div class="crater" style="width:5px;height:5px;top:3px;left:6px"></div><div class="crater" style="width:3px;height:3px;top:10px;left:12px"></div></div>
          <div class="model asteroid asteroid-3" data-label="Asteroid"><div class="crater" style="width:5px;height:5px;top:5px;left:10px"></div><div class="crater" style="width:4px;height:4px;top:12px;left:5px"></div></div>
          <!-- Shooting Stars -->
          <div class="shooting-star ss-1"><div class="ss-tail"></div><div class="ss-head"></div></div>
          <div class="shooting-star ss-2"><div class="ss-tail"></div><div class="ss-head"></div></div>
          <div class="shooting-star ss-3"><div class="ss-tail"></div><div class="ss-head"></div></div>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION 4: ASTROPHYSICS -->
  <section class="section" id="section-astrophysics">
    <div class="astro-phys-bg"></div>
    <div id="astrophysics-particles" style="position:absolute;inset:0;overflow:hidden;will-change:transform;transition:transform 0.1s linear"></div>
    <div class="section-content">
      <div class="left-col">
        <div class="tag" style="color:#F5A623;border-color:rgba(245,166,35,0.3)">🌟 Astrophysics</div>
        <h2 class="headline">The Physics of<br><span class="highlight-amber">Stars</span><br>& Galaxies</h2>
        <p class="body-text">Uncover the life cycle of stars, the expansion of the universe, and the physics behind the most extreme objects in existence — neutron stars, supernovae, and quasars.</p>
        <div class="cta-row"><button class="cta-btn cta-amber" data-auth="astrophysics">Explore Astrophysics →</button></div>
        <div class="feature-row amber"><span class="feature-icon">⭐</span><div><div class="feature-title">Stellar Evolution</div><div class="feature-desc">From nebula to white dwarf</div></div></div>
        <div class="feature-row amber"><span class="feature-icon">💥</span><div><div class="feature-title">Supernovae</div><div class="feature-desc">Stellar explosions and remnants</div></div></div>
        <div class="feature-row amber"><span class="feature-icon">🌀</span><div><div class="feature-title">Neutron Stars</div><div class="feature-desc">Pulsars and magnetars</div></div></div>
        <div class="feature-row amber"><span class="feature-icon">📡</span><div><div class="feature-title">Cosmological Expansion</div><div class="feature-desc">Hubble constant & redshift</div></div></div>
      </div>
      <div class="right-col">
        <div id="astrophysics-models" class="models-container">
          <!-- Supernova -->
          <div class="model supernova" data-label="Supernova">
            <div class="sn-core"></div>
            <div class="sn-glow"></div>
          </div>
          <!-- Pulsar -->
          <div class="model pulsar" data-label="Pulsar">
            <div class="pulsar-star"></div>
            <div class="pulsar-jet jet-t"></div>
            <div class="pulsar-jet jet-b"></div>
            <div class="jet-halo jh-top"></div>
            <div class="jet-halo jh-bottom"></div>
            <div class="pulsar-label">PULSAR</div>
          </div>
          <!-- Spectral Lines -->
          <div class="model spectral" data-label="Spectral Lines">
            <div class="spectral-container">
              <div class="spectral-line" style="left:8%;background:#FF4444"></div>
              <div class="spectral-line" style="left:19%;background:#FF8800"></div>
              <div class="spectral-line" style="left:29%;background:#FFFF00"></div>
              <div class="spectral-line" style="left:42%;background:#44FF44"></div>
              <div class="spectral-line" style="left:54%;background:#00AAFF"></div>
              <div class="spectral-line" style="left:67%;background:#0044FF"></div>
              <div class="spectral-line" style="left:77%;background:#8800FF"></div>
              <div class="spectral-line" style="left:88%;background:#FF44FF"></div>
            </div>
            <div class="spectral-label">Spectral Lines</div>
          </div>
          <!-- Cosmic Expansion -->
          <div class="model cosmic-expansion" data-label="Cosmic Expansion">
            <div class="expansion-core"></div>
            <div class="expansion-ring" style="width:40px;height:40px;animation:expandCosmic 3s ease-in-out infinite"></div>
            <div class="expansion-ring" style="width:80px;height:80px;opacity:0.8;animation:expandCosmic 3s ease-in-out infinite 0.4s"></div>
            <div class="expansion-ring" style="width:120px;height:120px;opacity:0.6;animation:expandCosmic 3s ease-in-out infinite 0.8s"></div>
            <div class="expansion-ring" style="width:160px;height:160px;opacity:0.4;animation:expandCosmic 3s ease-in-out infinite 1.2s"></div>
            <div class="expansion-ring" style="width:200px;height:200px;opacity:0.2;animation:expandCosmic 3s ease-in-out infinite 1.6s"></div>
            <div class="galaxy-dot" style="top:25%;left:30%"></div>
            <div class="galaxy-dot" style="top:60%;left:70%"></div>
            <div class="galaxy-dot" style="top:35%;right:15%"></div>
            <div class="galaxy-dot" style="bottom:25%;left:20%"></div>
            <div class="galaxy-dot" style="top:15%;right:30%"></div>
            <div class="galaxy-dot" style="bottom:35%;right:25%"></div>
            <div class="galaxy-dot" style="top:70%;left:45%"></div>
            <div class="galaxy-dot" style="bottom:15%;left:55%"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION 5: QUANTUM MECHANICS -->
  <section class="section" id="section-quantum">
    <div class="quantum-bg"></div>
    <div id="quantum-particles" style="position:absolute;inset:0;overflow:hidden;will-change:transform;transition:transform 0.1s linear"></div>
    <div class="section-content">
      <div class="left-col">
        <div class="tag" style="color:#7BC843;border-color:rgba(123,200,67,0.3)">⚛️ Quantum Mechanics</div>
        <h2 class="headline">The Strange World<br>of the<br><span class="highlight-lime">Quantum</span></h2>
        <p class="body-text">Enter the realm where particles exist in multiple places at once, cats are simultaneously alive and dead, and observation changes reality. Quantum mechanics will break your intuition — and rebuild it.</p>
        <div class="cta-row"><button class="cta-btn cta-lime" data-auth="quantum">Explore Quantum →</button></div>
        <div class="feature-row lime"><span class="feature-icon" style="color:#7BC843">〰</span><div><div class="feature-title">Wave-Particle Duality</div><div class="feature-desc">Light is both wave and particle</div></div></div>
        <div class="feature-row lime"><span class="feature-icon">📦</span><div><div class="feature-title">Schrödinger's Cat</div><div class="feature-desc">Superposition of quantum states</div></div></div>
        <div class="feature-row lime"><span class="feature-icon">🧱</span><div><div class="feature-title">Quantum Tunneling</div><div class="feature-desc">Particles pass through barriers</div></div></div>
        <div class="feature-row lime"><span class="feature-icon" style="color:#7BC843">△</span><div><div class="feature-title">Uncertainty Principle</div><div class="feature-desc">Δx · Δp ≥ ℏ/2</div></div></div>
      </div>
      <div class="right-col">
        <div id="quantum-models" class="models-container">
          <!-- Schrödinger's Cat -->
          <div class="model schrodinger" data-label="Schrödinger's Cat">
            <div class="cat-box">
              <div class="cat-lid"></div>
              <div class="cat-body"></div>
              <div class="cat-head"></div>
              <div class="cat-ear-l"></div>
              <div class="cat-ear-r"></div>
              <div class="cat-q">?</div>
            </div>
            <div class="cat-label">Schrödinger's Cat</div>
          </div>
          <!-- Uncertainty -->
          <div class="model uncertainty" data-label="Uncertainty Principle">
            <div class="unc-card">
              <div class="unc-line">Δx · Δp</div>
              <div class="unc-divider"></div>
              <div class="unc-line">≥ ℏ/2</div>
              <div class="unc-dots">
                <div class="unc-dot" style="width:8px;height:8px;opacity:0.3"></div>
                <div class="unc-dot" style="width:6px;height:6px;opacity:0.5"></div>
                <div class="unc-dot" style="width:4px;height:4px;opacity:0.8"></div>
                <div class="unc-dot" style="width:6px;height:6px;opacity:0.5"></div>
                <div class="unc-dot" style="width:8px;height:8px;opacity:0.3"></div>
              </div>
            </div>
            <div class="unc-label">Uncertainty Principle</div>
          </div>
          <!-- Tunneling -->
          <div class="model tunneling" data-label="Quantum Tunneling">
            <div class="tunnel-particle-in"></div>
            <div class="tunnel-barrier"></div>
            <div class="tunnel-particle-out"></div>
            <div class="tunnel-dash"></div>
            <div class="tunnel-arrow-l"></div>
            <div class="tunnel-arrow-r"></div>
          </div>
          <!-- Wave-Particle Duality -->
          <div class="model wave-particle" data-label="Wave-Particle Duality">
            <svg width="200" height="60" viewBox="0 0 200 60" style="overflow:visible">
              <path d="M0,30 Q25,0 50,30 T100,30 T150,30 T200,30" fill="none" stroke="#7BC843" stroke-width="3" stroke-dasharray="8 4" style="animation:waveDrift 1.5s linear infinite"/>
              <circle r="6" fill="#7BC843" style="filter:drop-shadow(0 0 8px #7BC843)">
                <animateMotion dur="1.5s" repeatCount="indefinite" path="M0,30 Q25,0 50,30 T100,30 T150,30 T200,30"/>
              </circle>
            </svg>
            <div class="wp-label">Wave-Particle Duality</div>
          </div>
          <!-- QM Entanglement -->
          <div class="model qm-entanglement" data-label="Quantum Entanglement">
            <div class="qm-ep qm-ep-l"></div>
            <div class="qm-ep qm-ep-r"></div>
            <div class="qm-conn"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
`;
